'use client'

import { useEffect, useRef } from 'react'
import { ErrorScreen } from '@/components/shared/ErrorScreen'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const reported = useRef(false)

  useEffect(() => {
    if (reported.current) return
    reported.current = true

    const payload = {
      message: error?.message ?? null,
      digest: error?.digest ?? null,
      stack: error?.stack ?? null,
      url: typeof window !== 'undefined' ? window.location.href : null,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : null,
      viewportHeight: typeof window !== 'undefined' ? window.innerHeight : null,
      buildId: typeof process !== 'undefined' ? (process.env.NEXT_PUBLIC_BUILD_ID ?? null) : null
    }

    try {
      const body = JSON.stringify(payload)
      const blob = new Blob([body], { type: 'application/json' })
      const sent =
        typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function'
          ? navigator.sendBeacon('/api/client-errors', blob)
          : false
      if (!sent) {
        fetch('/api/client-errors', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true
        }).catch(() => {})
      }
    } catch {
      // swallow — never let error boundary itself throw
    }
  }, [error])

  return <ErrorScreen onTryAgain={reset} errorMessage={error?.message ?? null} errorDigest={error?.digest ?? null} />
}
